module.exports = __webpack_public_path__ + "static/circles-8c2e91457a4b3d91383d3cbc1b6e1d3b.svg";